import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { KidAvatar } from "@/components/Avatars";

export default function KidContactRules({ hubId }) {
  const [d, setD] = useState(null);
  const load = () => api.get(`/organizations/${hubId}/connect/kids/rules`).then(({ data }) => setD(data)).catch(() => setD(null));
  useEffect(() => { load(); }, [hubId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const save = async (k, patch) => {
    const next = { mode: k.mode, approved: k.approved, family_chat: k.family_chat, ...patch };
    try { await api.put(`/organizations/${hubId}/connect/kids/${k.kid_id}/rules`, next); toast.success(`${k.name}'s contacts updated`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="mt-8" data-testid="kid-contact-rules">
      <h2 className="mb-3 font-display text-lg font-bold text-q-text">Who kids can message</h2>
      <div className="grid gap-4 md:grid-cols-2">
        {d.kids.map((k) => {
          const slug = k.name.toLowerCase();
          return (
            <div key={k.kid_id} className="q-card space-y-3" data-testid={`kid-rules-${slug}`}>
              <p className="flex items-center gap-2 font-display font-extrabold text-q-text"><KidAvatar avatar={null} size={28} /> {k.name}</p>
              <div className="flex flex-wrap gap-2" role="radiogroup">
                {[["anyone", "Anyone in the family"], ["approved", "Only people I approve"]].map(([v, l]) => (
                  <button key={v} role="radio" aria-checked={k.mode === v} onClick={() => save(k, { mode: v })} data-testid={`kid-rules-${slug}-${v}`}
                    className={`min-h-[44px] rounded-full border px-3 text-sm font-semibold ${k.mode === v ? "border-transparent text-white" : "border-q-line text-q-muted"}`}
                    style={k.mode === v ? { background: "rgb(var(--glow-connect))" } : undefined}>{l}</button>
                ))}
              </div>
              {k.mode === "approved" && (
                <div>
                  <p className="mb-2 text-xs text-q-faint">Parents are always allowed.</p>
                  <div className="flex flex-wrap gap-2">
                    {d.people.filter((p) => p.key !== `kid:${k.kid_id}`).map((p) => {
                      const on = k.approved.includes(p.key);
                      return <button key={p.key} aria-pressed={on} onClick={() => save(k, { approved: on ? k.approved.filter((x) => x !== p.key) : [...k.approved, p.key] })}
                        data-testid={`kid-rules-${slug}-approve-${p.name.split(" ").pop().toLowerCase()}`}
                        className={`min-h-[44px] rounded-full border px-3 text-sm font-semibold ${on ? "border-transparent bg-q-text text-q-bg" : "border-q-line text-q-muted"}`}>{p.name}</button>;
                    })}
                  </div>
                </div>
              )}
              <label className="flex min-h-[44px] items-center justify-between gap-3 text-sm font-semibold text-q-text">
                Family group chat
                <Switch checked={k.family_chat} onCheckedChange={(v) => save(k, { family_chat: v })} data-testid={`kid-rules-${slug}-family-chat`} />
              </label>
            </div>
          );
        })}
      </div>
    </section>
  );
}
